import { Box, InputBase, styled } from "@mui/material";
import { SearchIcon } from '../../../../Features/Table/Icons';

const Search = styled(Box)(({ theme }) => ({
    position: 'relative',
    borderRadius: '999px',
    backgroundColor: 'transparent',
    border: '1px solid #EBEFF3',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    cursor: 'pointer',
}));

const SearchIconWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(0, 0, 0, 1),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6B7280',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: '#6B7280',
    width: '100%',
    fontSize: '12px',
    paddingLeft: `calc(1em + ${theme.spacing(2)})`,
    paddingRight: theme.spacing(2),
    paddingTop: 0.5,
    paddingBottom: 0.5,
    transition: theme.transitions.create('width'),
}));

const SearchIconStyled = styled(SearchIcon)({
    fontSize: "16px",
    color: "#5E758D",
    padding: '0px'
});

export default function SignalsSelectionSearch({value, onChange}) {
    // const valueText = [null, undefined, ''].includes(value) ? '-' : `${value}`;
    // const valueUnit = valueText !== '-' ? keyMetric.unit : '';
    return (
        <Search>
            <SearchIconWrapper>
                <SearchIconStyled />
            </SearchIconWrapper>
            <StyledInputBase
                placeholder="Search Signal"
                value={value}
                onChange={onChange}
                inputProps={{ 'aria-label': 'search' }}
                sx={{}}
            />
        </Search>
    )
}
